
import { useState } from 'react';
import BottomNav from '../../components/base/BottomNav';
import Header from '../../components/base/Header';

export default function Sustentabilidade() {
  const [activeTab, setActiveTab] = useState<'ods' | 'produtos'>('ods');

  const ods = [
    {
      numero: 4,
      titulo: 'Educação de Qualidade',
      descricao: 'Assegurar a educação inclusiva e equitativa de qualidade',
      color: 'from-red-500 to-red-600',
      icon: 'ri-book-open-line',
    },
    {
      numero: 5,
      titulo: 'Igualdade de Gênero',
      descricao: 'Alcançar a igualdade de gênero e empoderar todas as mulheres',
      color: 'from-orange-500 to-orange-600',
      icon: 'ri-women-line',
    },
    {
      numero: 10,
      titulo: 'Redução das Desigualdades',
      descricao: 'Reduzir a desigualdade dentro dos países e entre eles',
      color: 'from-pink-500 to-pink-600',
      icon: 'ri-scales-line',
    },
    {
      numero: 12,
      titulo: 'Consumo Responsável',
      descricao: 'Assegurar padrões de produção e consumo sustentáveis',
      color: 'from-amber-500 to-amber-600',
      icon: 'ri-recycle-line',
    },
    {
      numero: 13,
      titulo: 'Ação Contra a Mudança do Clima',
      descricao: 'Tomar medidas urgentes para combater a mudança climática',
      color: 'from-green-500 to-green-600',
      icon: 'ri-earth-line',
    },
    {
      numero: 17,
      titulo: 'Parcerias pelas Metas',
      descricao: 'Fortalecer os meios de implementação e revitalizar parcerias',
      color: 'from-blue-500 to-blue-600',
      icon: 'ri-team-line',
    },
  ];

  const produtos = [
    {
      nome: 'Notebook Ecológico',
      descricao: 'Caderno feito com papel reciclado',
      pontos: 250,
      estoque: 15,
      imagem: 'https://public.readdy.ai/ai/img_res/aa2bb88f110ff4c9ebdf24bc30b081bd.jpg',
      color: 'from-green-500 to-emerald-500',
    },
    {
      nome: 'Kit de Canetas Sustentáveis',
      descricao: 'Canetas biodegradáveis de bambu',
      pontos: 180,
      estoque: 23,
      imagem: 'https://readdy.ai/api/search-image?query=set%20of%20five%20biodegradable%20bamboo%20pens%20with%20natural%20wood%20texture%2C%20arranged%20neatly%20on%20clean%20white%20surface%2C%20minimalist%20eco-friendly%20design%2C%20soft%20natural%20lighting%2C%20sustainable%20writing%20instruments%2C%20warm%20earth%20tones%2C%20professional%20product%20photography&width=400&height=400&seq=bamboo-pens-1&orientation=squarish',
      color: 'from-blue-500 to-cyan-500',
    },
    {
      nome: 'Mochila Sustentável',
      descricao: 'Mochila feita com garrafas PET recicladas',
      pontos: 500,
      estoque: 8,
      imagem: 'https://readdy.ai/api/search-image?query=modern%20sustainable%20backpack%20made%20from%20recycled%20PET%20bottles%2C%20sleek%20design%20in%20neutral%20gray%20color%2C%20durable%20fabric%20texture%2C%20clean%20white%20background%2C%20eco-friendly%20school%20bag%2C%20minimalist%20style%2C%20professional%20product%20photography%2C%20soft%20studio%20lighting&width=400&height=400&seq=backpack-pet-1&orientation=squarish',
      color: 'from-purple-500 to-pink-500',
    },
    {
      nome: 'Garrafa Reutilizável',
      descricao: 'Garrafa térmica de aço inoxidável',
      pontos: 320,
      estoque: 12,
      imagem: 'https://readdy.ai/api/search-image?query=sleek%20stainless%20steel%20reusable%20water%20bottle%20with%20matte%20finish%2C%20modern%20minimalist%20design%2C%20metallic%20silver%20color%2C%20clean%20white%20background%2C%20eco-friendly%20thermal%20bottle%2C%20professional%20product%20photography%2C%20soft%20natural%20lighting%2C%20sustainable%20lifestyle%20product&width=400&height=400&seq=bottle-steel-1&orientation=squarish',
      color: 'from-teal-500 to-cyan-500',
    },
  ];

  const impacto = [
    { label: 'Árvores Salvas', valor: '127', icon: 'ri-plant-line', color: 'text-green-500' },
    { label: 'CO₂ Reduzido', valor: '2.5t', icon: 'ri-leaf-line', color: 'text-emerald-500' },
    { label: 'Produtos Resgatados', valor: '45', icon: 'ri-gift-line', color: 'text-blue-500' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 pb-20">
      <Header title="Sustentabilidade" />

      <div className="pt-16 px-6">
        {/* Impacto */}
        <div className="mt-4 bg-gradient-to-r from-green-500 to-emerald-500 rounded-3xl shadow-lg p-6 text-white">
          <h2 className="text-xl font-bold mb-4">Seu Impacto Ambiental</h2>
          <div className="grid grid-cols-3 gap-4">
            {impacto.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-2">
                  <i className={`${item.icon} text-2xl`} />
                </div>
                <div className="text-2xl font-bold mb-1">{item.valor}</div>
                <div className="text-xs opacity-90">{item.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Tabs */}
        <div className="mt-6 bg-white rounded-full p-1 shadow-md flex">
          <button
            onClick={() => setActiveTab('ods')}
            className={`flex-1 py-2 px-1 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'ods'
                ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white'
                : 'text-gray-600'
            }`}
          >
            ODS da ONU
          </button>
          <button
            onClick={() => setActiveTab('produtos')}
            className={`flex-1 py-2 px-1 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
              activeTab === 'produtos'
                ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white'
                : 'text-gray-600'
            }`}
          >
            Produtos Sustentáveis
          </button>
        </div>

        {/* Content */}
        {activeTab === 'ods' ? (
          <div className="mt-6 space-y-4 mb-6">
            {ods.map((objetivo, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-5">
                <div className="flex items-start gap-4">
                  <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${objetivo.color} rounded-2xl text-white flex-shrink-0`}>
                    <i className={`${objetivo.icon} text-2xl`} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <span className={`px-3 py-1 bg-gradient-to-r ${objetivo.color} text-white rounded-full text-xs font-bold`}>
                        ODS {objetivo.numero}
                      </span>
                    </div>
                    <h3 className="font-bold text-gray-800 mb-2">{objetivo.titulo}</h3>
                    <p className="text-sm text-gray-600">{objetivo.descricao}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="mt-6 space-y-4 mb-6">
            {produtos.map((produto, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-md p-5">
                <div className="flex items-start gap-4">
                  <div className="w-20 h-20 flex-shrink-0 rounded-2xl overflow-hidden bg-gray-100">
                    <img 
                      src={produto.imagem} 
                      alt={produto.nome}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-800 mb-1">{produto.nome}</h3>
                    <p className="text-sm text-gray-600 mb-3">{produto.descricao}</p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <i className="ri-coin-line text-amber-500 text-lg" />
                        <span className="font-bold text-gray-800">{produto.pontos} pontos</span>
                      </div>
                      <span className="text-xs text-gray-500">{produto.estoque} disponíveis</span>
                    </div>
                    <button className="w-full mt-3 bg-gradient-to-r from-green-500 to-emerald-500 text-white py-2 rounded-full font-semibold text-sm cursor-pointer whitespace-nowrap">
                      Resgatar Agora
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <BottomNav />
    </div>
  );
}
